module.exports = __webpack_public_path__ + "static/img/gaozhonglishi.a57961e7.jpg";